// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ayah","title":"Info_title__1QzdI","links":"Info_links__3MWHe","link":"Info_link__3yYoU","logo":"Info_logo__3YdEb"};